import { isNull } from 'lodash';
import CartOrderTotals from 'components/common/cart/CartOrderTotals';
import ShadowCard from 'components/common/cards/ShadowCard';
import { useProducts } from 'contexts/ProductContext';
import ProductOrderStarterKitSection from './ProductOrderStarterKitSection';
import ProductOrderProductSection from './ProductOrderProductSection';
import ProductOrderPromoSection from './ProductOrderPromoSection';
import { useField } from 'hooks/useContentfulApi';
import { formState } from 'state';
import { useRecoilValue } from 'recoil';

export default function ProductOrder({ onUpdateCart }) {
  const [title] = useField('banner1Ref.fields.item6');
  const {
    state: { starterKit, products, promoItems },
  } = useProducts();
  const {
    countryInfo: { iso2: marketIso },
  } = useRecoilValue(formState);

  const marketsUsingNewDesign = ['JP'];
  const isMarketUsingNewDesign = marketsUsingNewDesign.includes(marketIso);

  // If there is no starter kit or products in cart, don't render.
  if (isNull(starterKit) && products.length === 0) {
    return null;
  }

  return (
    <ShadowCard title={title}>
      <div className="order-summary">
        <ProductOrderStarterKitSection
          starterKit={starterKit}
          onUpdateCart={onUpdateCart}
          allowEdit={!isMarketUsingNewDesign}
        />
        <ProductOrderProductSection
          products={products}
          onUpdateCart={onUpdateCart}
          allowEdit={!isMarketUsingNewDesign}
        />
        <ProductOrderPromoSection promos={promoItems} />
        <CartOrderTotals />
      </div>
    </ShadowCard>
  );
}
